import React from 'react';
import { SectionLabel } from './ui/SectionLabel';
const questions = ['What am I teaching tomorrow?', 'How do I make this class different from the last one?', 'Which sequence makes sense for this group?', 'What transitions should I use?', 'How do I adapt it for different levels?', 'What should I say throughout the class?', 'How do I turn this idea into a complete 45- or 60-minute session?'];
export function ProblemSection() {
  return <section className="w-full bg-ivory py-10 sm:py-14 lg:py-18" aria-labelledby="problem-heading" data-id="element-170" data-mp="39jyz1upvx0ou">
      <div className="mx-auto w-full max-w-content px-5 sm:px-8" data-id="element-171" data-mp="35idj20i206af">
        <div className="mx-auto max-w-2xl text-center" data-id="element-172" data-mp="3jer058ioe5od">
          <div className="flex justify-center" data-id="element-173" data-mp="3eh8mx5xml4ak">
            <SectionLabel data-id="element-174" data-mp="3ehic4rauj7f7">The reality</SectionLabel>
          </div>
          <h2 id="problem-heading" className="mt-3 font-serif text-[1.6rem] font-semibold uppercase leading-[1.1] text-ink sm:text-4xl" data-id="element-175" data-mp="1p197j73eyimh">
            Does this sound familiar?
          </h2>
          <p className="mt-4 text-[0.95rem] leading-relaxed text-muted sm:text-lg" data-id="element-176" data-mp="jeetatcxvtl6">
            You already know how to teach yoga. That’s not the problem.
            <span className="mt-1 block font-semibold text-ink" data-id="element-177" data-mp="se1sd8i74nb2">
              The problem is having to keep creating the classes.
            </span>
          </p>
        </div>

        <ul className="mx-auto mt-6 grid max-w-3xl gap-1.5 sm:grid-cols-2 sm:gap-2" data-id="element-178" data-mp="x6cv0j4bmn7b">
          {questions.map(question => <li key={question} className="rounded-xl border border-sandDark bg-cream/70 px-4 py-2.5 text-center font-serif text-[0.85rem] italic leading-snug text-muted sm:text-[0.95rem]" data-id="element-179" data-mp="1726cmgwwd6vy">
              “{question}”
            </li>)}
        </ul>

        <p className="mx-auto mt-5 max-w-md text-center text-[0.9rem] leading-relaxed text-ink sm:text-base" data-id="element-180" data-mp="3dtnmpzubon2x">
          And when that class is over… you have another one to prepare.
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-center font-serif text-[1.05rem] font-semibold uppercase leading-tight text-ink sm:text-2xl" data-id="element-181" data-mp="ozqva3qbbhty">
          Your teaching knowledge isn’t the problem.
          <span className="mt-1 block normal-case text-forest" data-id="element-182" data-mp="y1gmb8ga8er7">
            Having to rebuild the structure every week is.
          </span>
        </p>
      </div>
    </section>;
}